import { reportClientError } from '../services/clientErrorService';

let handlersInstalled = false;

export const setupGlobalErrorHandlers = () => {
  if (handlersInstalled || typeof window === 'undefined') {
    return;
  }

  handlersInstalled = true;

  window.addEventListener('error', (event) => {
    reportClientError({
      error: event.error || event.message,
      source: 'window_error',
      metadata: {
        filename: event.filename || null,
        lineno: event.lineno || null,
        colno: event.colno || null,
      },
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    reportClientError({
      error: event.reason,
      source: 'unhandled_rejection',
    });
  });
};
